<template>
  <div class="qrcode-warp">
    <!-- <div v-if="!showQRCode" class="spin-warp">
      <a-spin size="large" tip="生成二维码中..." />
    </div>
    <a-icon v-if="!showQRCode" class="qrcode-default" type="qrcode" /> -->
    <div>
      <slot name="describe"></slot>
    </div>
    <div class="qrcode-div" style="width: 280px">
      <vue-qr
        ref="vueQrcode"
        :correctLevel="3"
        :autoColor="false"
        :colorDark="color"
        :text="codeString"
        :logoSrc="logoString"
        :logoMargin="4"
        :logoScale="0.28"
        :size="400"
      />
    </div>
    <div>
      <slot name="describeBottom"></slot>
    </div>

    <div class="btn-warp" v-if="showDownloadBtn">
      <a-button
        style="margin: 0 5px"
        type="primary"
        icon="download"
        @click="handleDownLoadQRCode"
      >{{ $t('QRCode.downloadBtn') }}</a-button>

      <a-button
        v-if="refreshCodeFunc"
        style="margin: 0 5px"
        icon="sync"
        @click="refreshCodeFunc"
      > {{ $t('QRCode.refreshQRCode') }} </a-button>
    </div>

  </div>
</template>

<script>
import QRCode from 'qrcodejs2' // 引入qrcode
import vueQr from "vue-qr";
export default {
  name: 'QRCode-Component',
  components: {
    vueQr
  },
  props: {
    codeString: {
      type: String,
      default: ''
    },
    logoString: {
      type: String,
      default: ''
    },
    codeName: {
      type: String,
      default: ''
    },
    showDownloadBtn: {
      type: Boolean,
      default: true
    },
    refreshCodeFunc: {
      type: Function,
      default: null
    },
    color: {
      type: String,
      default: '#000000'
    }
  },
  data() {
    return {
      qrcode: null,
      showQRCode: false
    }
  },
  created() {
    this.$nextTick(() => {
      // this.createQrcode(this.codeString)
    })
  },
  computed: {},
  watch: {
    // codeString: function (newStr) {
    //   this.createQrcode(newStr)
    // },
    // logoString: function (newStr) {
    //   this.createQrcode(this.codeString)
    // }
  },
  methods: {
    // 生成二维码
    createQrcode(codeString) {
      document.getElementById('qrcode').innerHTML = ''
      try {
          this.qrcode = new QRCode('qrcode', {
          width: 214,
          height: 214, // 高度
          text: codeString, // 二维码内容
          render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f',   // 背景色
          // foreground: '#ff0'    // 前景色
          src: this.logoString,
        })
        if (this.logoString !== ''){
          this.createQrcodeLogo()
        }
        this.showQRCode = this.showDownloadBtn
      } catch (error) {
        this.$notification.error({
          message: this.$t('QRCode.createQRCodeFail'),
          description: ''
        })
      }
    },
    createQrcodeLogo(){
      // let logoBase64 = this.loadOSSImage(this.logoString)
      // if (!logoBase64){
      //   return
      // }
      // console.log(logoBase64)
      // return
      let logo = new Image();
      logo.setAttribute("crossOrigin", "Anonymous");
      logo.src = this.logoString;

      logo.onload = () => {
        let qrImg = this.qrcode._el.getElementsByTagName('img')[0];
        let canvas = this.qrcode._el.getElementsByTagName('canvas')[0];
        this.qrcode._el.title = "";
        canvas.style.display = "inline-block";
        let ctx = canvas.getContext("2d");
        // 设置logo的大小为二维码图片缩小的3.7倍
        ctx.drawImage(logo, (200 - 200 / 3.7) / 2, (200 - 200 / 3.7) / 2, 200 / 3.7, 200 / 3.7);
        qrImg.src = canvas.toDataURL();
        qrImg.style.display = "none";
        this.$refs.qrCode.appendChild(this.qrcode._el);
      }
    },
    // 下载二维码
    handleDownLoadQRCode() {
      // //找到canvas标签
      // return
      // let myCanvas = document
      //   .getElementById('qrcode')
      //   .getElementsByTagName('canvas')
      // let img = document.getElementById('qrcode').getElementsByTagName('img')
      // // // //创建一个a标签节点
      let a = document.createElement('a')
      // // //设置a标签的href属性（将canvas变成png图片）
      // let imgURL = myCanvas[0].toDataURL('image/jpg')
      let imgURL = this.$refs.vueQrcode.imgUrl
      let ua = navigator.userAgent
      if (ua.indexOf('Trident') !== -1 && ua.indexOf('Windows') !== -1) {
        // IE内核 并且  windows系统 情况下 才执行;
        var bstr = atob(imgURL.split(',')[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        var blob = new Blob([u8arr])
        window.navigator.msSaveOrOpenBlob(
          blob,
          (this.codeName || '') + this.$t('QRCode.QRCodeFileName') + '.' + 'png'
        )
      } else if (ua.indexOf('Firefox') > -1) {
        // 火狐兼容下载
        let blob = this.base64ToBlob(imgURL) // new Blob([content]);
        let evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', true, true) // initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        a.download = (this.codeName || '') + this.$t('QRCode.QRCodeFileName') // 下载图片名称，如果填内容识别不到，下载为未知文件，所以我这里就不填为空
        a.href = URL.createObjectURL(blob)
        a.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          })
        ) // 兼容火狐
      } else {
        // 谷歌兼容下载
        // img.src = myCanvas[0].toDataURL('image/jpg')
        // a.href = myCanvas[0].toDataURL('image/png').replace('image/png', 'image/octet-stream')
        a.href = imgURL
        // 设置下载文件的名字
        a.download = (this.codeName || '') + this.$t('QRCode.QRCodeFileName')
        // 点击
        a.click()
      }
    },
    // base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length
      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], { type: contentType })
    },
  }
}
</script>

<style scoped>
.qrcode-warp {
  text-align: center;
  position: relative;
}
.qrcode-default {
  font-size: 250px;
}
.spin-warp {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding-top: 20%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1;
}

#qrcode {
  display: inline-block;
  padding: 20px;
}
.qrcode-div{
  display: inline-block;
  width: 280px;
}
.qrcode-div> img{
  padding: 20px;
  width: 100% !important;
}
</style>
